import { combineReducers } from '@reduxjs/toolkit';
import { authentication } from './auth.reducer';
export default combineReducers({
    authentication
});